import Vue from 'vue'
import Router from 'vue-router'

const Secrecy = () => import('@/page/secrecy/secrecy.vue') //隱私政策頁面


Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'Secrecy',
    component: Secrecy
  }]
})



// WEBPACK FOOTER //
// ./src/page/secrecy/router.js